<template>
  <div class="AgeSet">
    <div class="top">
      <div class="t_l">
        <div class="t_l_item">
          <template v-if="editForm">
            <span style="margin-right: 8px">年龄匹配</span>
            <a-switch v-model="openSetting" />
          </template>
          <template v-else>
            <span style="margin-right: 8px">年龄匹配：{{ openSetting ? '开启' : '关闭' }}</span>
          </template>
        </div>
      </div>
      <div class="t_r" v-permission="`Content.MatchSeting.AgeAdd`">
        <a-button v-if="editForm" type="primary" style="margin-right: 15px" @click="isadd()">新增匹配</a-button>
      </div>
    </div>
    <div class="bottom tableForm">
      <a-form-model ref="tableForm" :model="tableForm" labelAlign="right">
        <a-table :columns="columns" :data-source="tableForm.dataSource" :pagination="false" bordered size="middle">
          <div slot="minAge" slot-scope="text, record, index">
            <span v-if="!editForm">{{ record.minAge }}</span>
            <a-form-model-item v-else :prop="`dataSource[${index}].minAge`" label="" :rules="tableFormRules()">
              <a-input-number v-model="record.minAge" :precision="0" :min="0" :max="150" />
            </a-form-model-item>
          </div>
          <div slot="maxAge" slot-scope="text, record, index">
            <span v-if="!editForm">{{ record.maxAge }}</span>
            <a-form-model-item v-else label="" :prop="`dataSource[${index}].maxAge`" :rules="tableFormRules()">
              <a-input-number v-model="record.maxAge" :precision="0" :min="0" :max="150" />
            </a-form-model-item>
          </div>
          <div slot="level" slot-scope="text, record, index">
            <a-form-model-item label="" :prop="`dataSource[${index}].levelSign`" :rules="[{ required: true, message: '请选择关卡' }]">
              <a-select :disabled="!editForm" v-model="record.levelSign" :key="record.levelSign" :default-value="record.levelSign" placeholder="请选择关卡" style="width: 100%">
                <template v-for="item in levelList">
                  <a-select-option v-if="item.levelName != '练习关'" :value="item.levelSign" :text="item.levelName" :key="item.id">{{ item.levelName }}</a-select-option>
                </template>
              </a-select>
            </a-form-model-item>
          </div>
          <div slot="action" slot-scope="text, record">
            <a v-if="editForm" style="color: #f00" @click="removeLevel(record)"> <a-icon type="delete" />删除 </a>
          </div>
        </a-table>
      </a-form-model>

      <div class="subBox" v-permission="`Content.MatchSeting.AgeSave`">
        <a-button v-if="editForm" type="primary" @click="submit()">保存</a-button>
        <a-button v-else type="primary" @click=";(editForm = true), setIsSave(false)">编辑</a-button>
      </div>
    </div>
    <!-- 切换等级体系 -->
    <a-modal v-model="ismodle" title="新增匹配" @ok="addagematch">
      <a-form-model ref="ruleForm" centered :model="modleForm" :rules="modleRules" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
        <a-form-model-item ref="ages" label="年龄范围" prop="ages">
          <div class="inputBox">
            <a-input-number v-model="modleForm.MinAge" type="number" :precision="0" :max="120" :min="1" />
            <em>-</em>
            <a-input-number v-model="modleForm.MaxAge" type="number" :precision="0" :max="120" :min="1" />
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { saveMatchSetting, getMatchSetting } from '@/utils/http'

const columns = [
  {
    title: '年龄范围',
    align: 'center',
    children: [
      {
        title: '最小年龄',
        dataIndex: 'minAge',
        scopedSlots: { customRender: 'minAge' },
        align: 'center',
        key: 'minAge',
      },
      {
        title: '最大年龄',
        dataIndex: 'maxAge',
        align: 'center',
        scopedSlots: { customRender: 'maxAge' },
        key: 'maxAge',
      },
    ],
  },
  { title: '初始关卡设置', key: 'level', scopedSlots: { customRender: 'level' }, align: 'center' },
  { title: '', scopedSlots: { customRender: 'action' }, align: 'center' },
]
const tableFormRules = () => [{ required: true, message: '请填写内容', trigger: 'blur' }]
export default {
  name: 'AgeSet',
  inject: ['setIsSave'],
  data() {
    return {
      columns,
      tableForm: {
        dataSource: [],
      },
      editForm: false,
      openSetting: false,
      abilityEvaluationSysId: '',
      gameId: '',
      pageIndex: 1,
      pageSize: 10,
      levelList: [],
      contentName: '',
      detailList: [],
      UseFirstAbility: 1,
      MultipleAbilitySocreProcessType: 2,
      status: false,
      contentId: '',

      // 切换等级体系
      ismodle: false,
      modleForm: {
        MinAge: '',
        MaxAge: '',
        ages: '',
      },
      modleRules: {
        ages: [{ required: true, message: '请输入年龄范围', trigger: 'blur' }],
      },
      queryList: [],
    }
  },
  created() {
    this.levelSelect()
  },
  methods: {
    removeLevel(record) {
      this.tableForm.dataSource = this.tableForm.dataSource.filter((v) => v.id != record.id)
    },
    initDefaultConfig() {
      const dataSource = []
      const len = defaultLevel.length
      for (let i = 0; i < Math.min(len, 41); i++) {
        const cuuentitem = defaultLevel[i]
        const item = {
          maxAge: cuuentitem.maxScore,
          minAge: cuuentitem.minScore,
          levelSign: i + 1,
          id: i,
        }
        dataSource.push(item)
      }
      this.tableForm.dataSource = dataSource
    },
    tableFormRules,
    agematch() {
      if (this.gameId) {
        let formData = new FormData()
        formData.append('id', this.gameId)
        this.$http.agematch(formData).then((res) => {
          console.log(res)
            this.$message.destroy()
            this.$message.success(res.data.message)
        })
      } else {
      }
    },
    getRecord(item, record) {
      this.queryList.forEach((el) => {
        if (el.gameLevelMatchSettingDetailId == record.id) {
          el.gameLevelMatchSettingDetailId = record.id
          el.levelSign = item ? item.levelSign : '-1'
        }
      })
    },
    // 保存
    async submit() {
      if (this.repeatScoreValidator()) {
        return this.$message.error('年龄范围重复')
      }
      this.$refs['tableForm'].validate(async (valid) => {
        if (valid) {
          let params = {
            id: this._settingId,
            contentId: this.$route.query.id,
            settingType: 3,
            status: this.openSetting,
            settingDetails: this.tableForm.dataSource.map((v) => ({
              levelSign: v.levelSign,
              minStandard: v.minAge,
              maxStandard: v.maxAge,
            })),
          }
          const { data } = await saveMatchSetting(params)
            this.$message.success(data.message)
            this.editForm = false
            this.setIsSave(true)
         
        }
      })
    },
    async getMatchSettingInfo() {
      const { data } = await getMatchSetting({
        contentId: this.$route.query.id,
        settingType: 3,
      })
        const { id, settingDetails, status } = data.data || {}
        if (!settingDetails?.length) {
        } else {
          this.tableForm.dataSource = settingDetails?.map((v, i) => ({
            levelSign: v.levelSign,
            minAge: v.minStandard,
            maxAge: v.maxStandard,
            id: i,
          }))
        }
        this._settingId = id
        this.openSetting = status
    },
    isadd() {
      this.modleForm = {
        MinAge: '',
        MaxAge: '',
        ages: '',
      }
      this.ismodle = true
    },
    repeatScoreValidator(data = []) {
      const tableSet = new Set()
      const setScore = (min, max) => {
        for (let i = min; i <= max; i++) {
          if (tableSet.has(i)) {
            return false
          } else {
            tableSet.add(i)
          }
        }
        return true
      }
      data = data.concat(this.tableForm.dataSource)
      return data.some((item) => {
        const isRepeat = setScore(+item.minAge, +item.maxAge)
        return !isRepeat
      })
    },
    addagematch() {
      if (!this.modleForm.MinAge || !this.modleForm.MaxAge) {
        this.$message.destroy()
        this.$message.error('必填项不能为空')
        return
      }
      let params = {}
      if (this.gameId) {
        params = {
          GameLevelMatchSettingId: this.gameId,
          contentId: this.$route.query.id,
          status: this.status,
          minAge: this.modleForm.MinAge,
          maxAge: this.modleForm.MaxAge,
          id: +new Date(),
        }
      } else {
        params = {
          contentId: this.$route.query.id,
          status: this.status,
          minAge: this.modleForm.MinAge,
          maxAge: this.modleForm.MaxAge,
          id: +new Date(),
        }
      }
      if (this.repeatScoreValidator([params])) {
        return this.$message.error('年龄范围重复')
      }
      this.tableForm.dataSource.push(params)
      this.ismodle = false
      
    },
    delagematch(record) {
      let formData = new FormData()
      formData.append('id', record.id)
      this.$http.delagematch(formData).then((res) => {
          this.levelSelect()
          this.$message.success('删除成功')
          this.ismodle = false
       
      })
    },
    getagematchlist() {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        GameLevelMatchSettingId: this.gameId,
      }
      this.$http.getagematchlist(params).then((res) => {
          if (this.levelList) {
            this.dataSource = res.data.data
            this.detailList.forEach((item) => {
              this.dataSource.forEach((el) => {
                if (item.id == el.id) {
                  el.levelSign = item.levelSign == -1 ? undefined : item.levelSign
                  el.levelId = item.id
                }
              })
            })
          } else {
            this.dataSource = res.data.data
            this.detailList.forEach((item) => {
              this.dataSource.forEach((el) => {
                if (item.id == el.id) {
                  el.levelSign = item.levelSign == -1 ? undefined : item.levelSign
                  el.levelId = item.id
                }
              })
            })
        }
      })
    },
    levelSelect() {
      let formData = new FormData()
      formData.append('tainGameId', this.$route.query.id)
      this.$http.levelSelect(formData).then((res) => {
          this.levelList = res.data.data.filter((v) => v.levelName != '练习关').slice(0, 41)
          this.getMatchSettingInfo()
      })
    },
    clearSet() {
      let formData = new FormData()
      formData.append('gameLevelMatchSettingId', this.gameId)
      this.$http.clearSet(formData).then((res) => {
          this.getagematchlist()
          this.$message.destroy()
          this.$message.success('操作成功')
      })
    },
  },
}
</script>

<style scoped>
/deep/ .searchForm {
  display: flex;
}
/deep/ .searchForm .fold {
  width: 91%;
  display: flex;
}
</style>
<style scoped lang="less">
.tableForm {
  ::v-deep .ant-form-item {
    margin-bottom: 0px;
  }
}
.top {
  display: flex;
  justify-content: space-between;
  .t_l {
    display: flex;
    align-items: center;
    .t_l_item {
      margin-left: 30px;
    }
    .ant-btn-primary {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 20px;
      margin-left: 20px;
    }
    em {
      color: #d2d2d2;
      font-size: 14px;
      font-style: normal;
      margin-left: 15px;
      cursor: pointer;
    }
  }
}
.bottom {
  margin-top: 15px;
}
.subBox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  position: fixed;
  z-index: 10;
  bottom: 0;
  right: 35px;
  background: #fff;
  padding: 8px 0;
  width: calc(100% - 15% - 48px - 256px);
}
.inputBox {
  display: flex;
  align-items: center;
  em {
    margin: 0 5px;
  }
}
</style>
